const membershipStatusOptions = [
  { 
    value: 'proposed',
    label: 'Proposed',
    icon: 'help',
    iconLibrary: 'material',
    description: 'Membership is proposed but not yet accepted',
  },
  { 
    value: 'active',
    label: 'Active',
    icon: 'check_circle',
    iconLibrary: 'material',
    description: 'Currently an active member',
  },
  { 
    value: 'inactive',
    label: 'Inactive',
    icon: 'pending',
    iconLibrary: 'material',
    description: 'Not an active member',
  },
  { 
    value: 'deleted',
    label: 'Deleted',
    icon: 'close',
    iconLibrary: 'material',
    description: 'q1 Network membership has been deleted',
  },
];
const membershipStatusMap = Object.fromEntries(membershipStatusOptions.map((o) => [o.value, o]));

const membershipRoleOptions = [
  {
    value: 'supporter',
    label: 'Supporter',
    icon: 'diversity_3',
    iconLibrary: 'material',
    description: 'FIXME',
  },
  {
    value: 'contributor',
    label: 'Contributor',
    icon: 'communities',
    iconLibrary: 'material',
    description: 'FIXME',
  },
  { 
    value: 'organizer',
    label: 'Organizer',
    icon: 'crowdsource',
    iconLibrary: 'material',
    description: 'FIXME',
  },
  {
    value: 'point',
    label: 'Point',
    icon: 'assistant_navigation',
    iconLibrary: 'material',
    description: 'FIXME',
  },
];
const membershipRoleMap = Object.fromEntries(membershipRoleOptions.map((o, index) => [o.value, {
  ...o,
  index,
}]));

const joinFlowOptions = [
  {
    value: 'invite',
    label: 'Invited',
  },
  {
    value: 'request',
    label: 'Requested',
  },
  {
    value: 'point',
    label: 'Point',
  },
];
const joinFlowMap = Object.fromEntries(joinFlowOptions.map((o) => [o.value, o]));

const membershipSubjectVisibilityOptions = [
  { 
    value: 'public',
    label: 'Public',
    icon: 'public',
    iconLibrary: 'material',
    description: 'Profile is visible on the public internet',
    availableAt: ['activated', 'launched'],
  },
  {
    value: 'network',
    label: 'Network',
    icon: 'q1-logo',
    iconLibrary: 'q1',
    description: 'Profile is visible to members of the q1 Network',
    availableAt: ['seeded', 'activated', 'launched'],
  },
  {
    value: 'project-network',
    label: 'Project Network',
    icon: 'hub',
    iconLibrary: 'material',
    description:
      'Profile visible to members & followers of the project, plus members of connected guilds',
    availableAt: ['seeded', 'activated', 'launched'],
  },
  {
    value: 'link',
    label: 'Private Link',
    icon: 'link',
    iconLibrary: 'material',
    description: 'Profile is private & unlisted, visible to any q1 Network members with link.',
    availableAt: ['created', 'seeded', 'activated', 'launched'],
  },
  {
    value: 'private',
    label: 'Private',
    icon: 'communities',
    iconLibrary: 'material',
    description: 'Profile is only visible to members of the parent guild/project',
    availableAt: ['created', 'seeded', 'activated', 'launched'],
  },
];
const membershipSubjectVisibilityMap = Object.fromEntries(
  membershipSubjectVisibilityOptions.map((o) => [o.value, o])
);

const membershipSubjectCollection = {
  guildMembers: 'guilds',
  projectMembers: 'projects',
  guildProjects: 'guilds',
};

/*=== EXPORTS ===*/

export {
  membershipStatusOptions,
  membershipStatusMap,

  membershipRoleOptions,
  membershipRoleMap,

  joinFlowOptions,
  joinFlowMap,

  membershipSubjectVisibilityOptions,
  membershipSubjectVisibilityMap,

  membershipSubjectCollection,
};
